import { Switch, withStyles } from '@material-ui/core';

export const AntSwitch = withStyles(theme => ({
  root: {
    width: 38,
    height: 20,
    padding: 0,
    margin: 0,
    display: 'flex',
  },
  switchBase: {
    width: 14,
    height: 14,
    margin: 3,
    color: theme.palette.grey[500],

    '&$checked': {
      transform: 'translateX(18px)',
      color: theme.palette.primary.main,
    },

    '&$checked + $track': {
      opacity: '54%',
      backgroundColor: theme.palette.primary.main,
    },

    '&$checked .MuiSwitch-thumb': {
      backgroundColor: theme.palette.primary.main,
    },
  },

  thumb: {
    width: 12,
    height: 12,
    margin: 0,
    boxShadow: 'none',
    backgroundColor: theme.b2chatblue[100],
  },
  track: {
    width: 38,
    borderRadius: '80px',
    opacity: 1,
    backgroundColor: theme.b2chatgray[600],
  },
  checked: {},
}))(Switch);

export default AntSwitch;
